import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';

const TripMap = ({ trip }) => {
  const [mapSrc, setMapSrc] = useState('');
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Generate map URL based on destination name instead of coordinates
    if (trip?.destination || trip?.primaryPark || trip?.park) {
      const location = trip?.destination || trip?.primaryPark || trip?.park;
      
      // Use Google Maps with place name for accurate location
      const encodedLocation = encodeURIComponent(location);
      const newMapSrc = `https://www.google.com/maps?q=${encodedLocation}&z=12&output=embed`;
      
      setMapSrc(newMapSrc);
      setIsLoading(false);
    } else if (trip?.coordinates?.lat && trip?.coordinates?.lng) {
      // Fallback to coordinates if no location name
      const newMapSrc = `https://www.google.com/maps?q=${trip?.coordinates?.lat},${trip?.coordinates?.lng}&z=12&output=embed`;
      setMapSrc(newMapSrc);
      setIsLoading(false);
    }
  }, [trip?.destination, trip?.primaryPark, trip?.park, trip?.coordinates]);

  return (
    <div className="bg-card rounded-organic shadow-organic overflow-hidden">
      <div className="p-6 border-b border-border">
        <h3 className="font-heading font-heading-bold text-lg text-foreground flex items-center gap-2">
          <Icon name="Map" size={20} />
          Trip Location
        </h3>
        <p className="font-body text-muted-foreground text-sm mt-1">
          {trip?.destination || trip?.primaryPark || trip?.park}
        </p>
      </div>
      <div className="relative h-64 lg:h-80">
        {isLoading ? (
          <div className="w-full h-full flex items-center justify-center bg-muted">
            <Icon name="Loader" size={24} className="text-muted-foreground animate-spin" />
          </div>
        ) : (
          <iframe
            width="100%"
            height="100%"
            loading="lazy"
            title={trip?.destination || trip?.primaryPark || 'Trip Location'}
            referrerPolicy="no-referrer-when-downgrade"
            src={mapSrc}
            className="border-0"
          />
        )}
      </div>
      <div className="p-6">
        <div className="space-y-3">
          <div className="flex items-start gap-3">
            <Icon name="Navigation" size={16} className="text-muted-foreground mt-1" />
            <div>
              <p className="font-body font-body-medium text-sm text-foreground">
                Driving Directions
              </p>
              <p className="font-body text-sm text-muted-foreground">
                {trip?.drivingDirections || `Navigate to ${trip?.destination || trip?.primaryPark || trip?.park}`}
              </p>
            </div>
          </div>
          
          <div className="flex items-start gap-3">
            <Icon name="Clock" size={16} className="text-muted-foreground mt-1" />
            <div>
              <p className="font-body font-body-medium text-sm text-foreground">
                Travel Time
              </p>
              <p className="font-body text-sm text-muted-foreground">
                {trip?.travelTime || 'Varies by starting location'}
              </p>
            </div>
          </div>

          <div className="flex items-start gap-3">
            <Icon name="MapPin" size={16} className="text-muted-foreground mt-1" />
            <div>
              <p className="font-body font-body-medium text-sm text-foreground">
                Park Address
              </p>
              <p className="font-body text-sm text-muted-foreground">
                {trip?.parkAddress || `${trip?.destination || trip?.primaryPark || trip?.park} Visitor Center`}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TripMap;